"use client";
import React from 'react';

// Next
import Link from 'next/link';
import Image from 'next/image';

// Components
import MenuItem from '../menuItem';
import Menu from './menu';
import Mobile from './mobile';
import More from './more';
import HeaderSearch from '@/search/component/header-search';
import AuthBanner from '@src/app/(main)/(public)/(auth)/authbanner';

// Constants
import { MenuItems } from '@ui/header/constants';

// Store
import useStore from '@store';


export default () => {
	const $state = useStore();
	const { user } = $state?.auth || {};

	return (
		<>
			<div className='h-[97px] w-full'></div>
			<header
				className={`
					h-[97px] flex flex-row w-full px-4  sm:px-16 justify-start
					lg:justify-between items-center m-0 gap-2 fixed z-50
					top-0 bg-[#212A56] shadow-black/10 shadow-lg
				`}
			>
				{/* Mobile Menu */}
				<Mobile />

				{/* MKTV Logo */}
				<Link href={`/`} className={`flex`}>
					<Image
						//className='w-48 min-w-[160px] max-w-[180px] md:max-w-[unset] sm:w-32'
						className='min-w-24 w-36'
						src='/images/general/logo.svg'
						alt='MuslimKidsTV'
						width={128}
						height={48}></Image>
				</Link>
				<nav className='hidden xl:flex flex-row justify-center flex-1 relative gap-2 lg:gap-4'>
					{MenuItems.map((item, index) => {
						return <MenuItem item={item} key={index} />;
					})}
					<More />
				</nav>

				<div className={`flex flex-1 xl:flex-[unset] items-center justify-end gap-4 md:gap-8`}>
					{/* Search Panel */}
					<HeaderSearch/>
					{/* User Menu */}
					{user && <Menu/>}
				</div>

				{/* Swirl  */}
				<div
					className={`
						absolute top-0  right-0 w-[550px] h-full
						bg-no-repeat bg-[url('/images/header/bg-swirl.webp')]
						z-[-1] bg-cover bg-[235px_52%] sm:bg-[185px_52%]
					`}
				/>
			</header>

			{/* Auth Banner (For non-authenticated users ) */}
			{!user && <AuthBanner />}
		</>
	);
}
